// extracted by mini-css-extract-plugin
module.exports = {"new":"index_new_dVggl","favorite":"index_favorite_lXj90","thumb":"index_thumb_2a8bR","image":"index_image_2mPym"};